export default __webpack_public_path__ + "static/media/gem-icon.21811c35.png";